// extracted by mini-css-extract-plugin
export default {"mobileMenu":"styles_mobileMenu__9rrA6","buttonsBlock":"styles_buttonsBlock__UuyRz","shine":"styles_shine__R3l02","active":"styles_active__EMwlP"};